import styled from 'styled-components';
import { AnchorIcon } from 'ui-components/src/components/atoms/icons/AnchorIcon';

export const Container = styled.div``;

export const BillingIcon = styled(AnchorIcon)`
  fill: ${({ theme }) => theme.colors.primary.cyan};
  height: 1.25rem;
  width: 1.25rem;
  margin-right: 1rem;
`;
